<template>
  <v-data-table
    item-key="id"
    :headers="headers"
    :loading="loading"
    :items="users"
    :items-per-page="10"
    :disable-sort="$vuetify.breakpoint.smAndDown"
    :footer-props="{'items-per-page-text': 'Số Mã hồ sơ một trang'}"
    v-bind="this.$attrs"
  >
    <template v-slot:[`footer.page-text`]="items">
      Tài khoản thứ {{ items.pageStart }} - {{ items.pageStop }} trên tổng {{ items.itemsLength }} Tài khoản
    </template>
    <template v-slot:[`item.username`]="{item}">
      {{ item | getUsername }}
    </template>
    <template v-slot:[`item.name`]="{item}">
      <a :href="`/admin/sale/${item.id}`" class="clickable-text">
        {{ item | getName }}
      </a>
    </template>
    <template v-slot:[`item.createdAt`]="{item}">
      {{ item | getCreatedAt }}
    </template>
    <template v-slot:[`item.blocked`]="{item}">
      {{ item | getStatus }}
    </template>
    <template v-slot:[`item.isConfirmedOTP`]="{item}">
      <v-chip color="success d-flex justify-center" style="width: 120px" v-if="item.isConfirmedOTP" label
        >Đã kích hoạt</v-chip
      >
      <v-chip color="gray d-flex justify-center" style="width: 120px" v-else label>Chưa kích hoạt</v-chip>
    </template>
    <template v-slot:[`item.SMSNum`]="{item}">
      {{ item | getSMSNum }}
    </template>
    <template v-slot:[`item.documents`]="{item}">
      <v-progress-circular indeterminate color="primary" v-if="loadings[`${item.username}`]"></v-progress-circular>
      <div class="d-flex align-center" :class="{'justify-center': item.cvs.length === 0}" v-else>
        <div v-if="item.cvs.length === 0">
          Chưa tạo hồ sơ
        </div>
        <v-chip-group v-else column>
          <v-chip v-for="document in item.cvs" :key="document.id" color="primary">
            {{ document.code }}
          </v-chip>
        </v-chip-group>
      </div>
    </template>
  </v-data-table>
</template>

<script>
/* eslint-disable no-unused-vars */
const originHeaders = [
  {
    text: 'Họ tên',
    value: 'name',
    align: 'left',
    sortable: false,
    show: true,
    width: '20%'
  },
  {
    text: 'Tên đăng nhập',
    value: 'username',
    align: 'left',
    sortable: false,
    show: true,
    width: '20%'
  },
  {
    text: 'Email',
    value: 'email',
    align: 'left',
    sortable: false,
    show: true,
    width: '20%'
  },
  {
    text: 'Ngày tạo',
    value: 'createdAt',
    align: 'left',
    sortable: false,
    show: true,
    width: '20%'
  },
  {
    text: 'Trạng thái',
    value: 'blocked',
    align: 'left',
    sortable: false,
    show: true,
    width: '150'
  }
]

import {mapGetters} from 'vuex'
import {get} from 'lodash'
import moment from 'moment'
moment.locale('vi')

export default {
  props: {
    users: Array
  },
  computed: {
    ...mapGetters('activeCode', ['activeCodes', 'activeCode']),
    ...mapGetters('auth', ['role', 'user', 'isAuthenticated'])
  },
  data() {
    return {
      loading: false,
      headers: originHeaders,
      selectedActiveCode: {},
      confirmDialog: false,
      loadings: {}
    }
  },
  created() {
    this.loading = true
  },
  methods: {},
  watch: {
    users() {
      this.loading = false
    }
  },
  filters: {
    getUsername: item => {
      return get(item, 'username', 'Chưa có thông tin')
    },
    getName: item => {
      return get(item, 'name', 'Chưa có thông tin')
    },
    getCreatedAt: item => {
      if (item.createdAt) return moment(item.createdAt).format('DD/MM/YYYY')
      return 'Chưa có thông tin'
    },
    getStatus: item => {
      if (item.blocked === false) {
        return 'Đang hoạt động'
      } else if (item.blocked === true) {
        return 'Đã bị khóa'
      } else {
        return ''
      }
    }
  }
}
/* eslint-enable no-unused-vars */
</script>

<style scoped>
.v-data-table {
  overflow-x: auto !important;
}
</style>
